import { Component } from 'react'
import { Helmet } from 'react-helmet'
import { compose } from 'redux'
import { appConnect } from '~/store/hooks'
import PropTypes from 'prop-types'
import * as filestack from 'filestack-js'

import FILESTACK_API_KEY from 'config/filestack'
import routes from 'config/routes'
import { getTitle } from 'config/titles'
import { updateBackgroundImage } from 'store/objects'

import { Modal, MODAL_ANIMATION_VARIANT } from '~/ui/Modal'
import { Dialog } from '~/ui/Dialog'
import { Heading } from 'react-aria-components'
import { withNavigate } from '~/utils/reactRouterHOC'

class EditImageModal extends Component {
  static propTypes = {
    props: PropTypes.object,
    navigate: PropTypes.func,
    match: PropTypes.object,
    backgroundImage: PropTypes.object,
    onUpdateBackgroundImage: PropTypes.func,
  }

  state = {
    isOpen: true,
  }

  componentDidMount() {
    this.client = filestack.init(FILESTACK_API_KEY)
    this.handleLoadImage(this.props.backgroundImage)
  }

  componentWillUnmount() {
    this.closePicker()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.backgroundImage.BACKGROUND_IMAGE && nextProps.backgroundImage.BACKGROUND_IMAGE) {
      this.handleLoadImage(nextProps.backgroundImage)
    }
  }

  createPicker = () => {
    this.picker = this.client.picker({
      onUploadDone: this.handleFileUploadFinished,
      customText: {
        Save: 'Apply',
        Upload: 'Save',
      },
      displayMode: 'inline',
      container: '#filestack-ref',
    })
  }

  openPicker = backgroundImage => {
    this.picker.crop([backgroundImage.BACKGROUND_IMAGE.src])
  }

  closePicker = () => {
    if (this.picker) this.picker.close()
  }

  handleLoadImage = backgroundImage => {
    if (backgroundImage && backgroundImage.BACKGROUND_IMAGE && backgroundImage.BACKGROUND_IMAGE.src) {
      this.createPicker()
      this.openPicker(backgroundImage)
    }
  }

  handleFileUploadFinished = files => {
    files.filesUploaded.forEach(file => {
      this.client
        .metadata(file.handle, { width: true, height: true })
        .then(res => {
          this.handleSave({
            file,
            res,
          })
        })
        .catch(() => {})
    })
  }

  handleSave = async ({ file, res }) => {
    const { navigate } = this.props
    const { url } = file
    const { width, height } = res

    this.props.onUpdateBackgroundImage({
      ...this.props.backgroundImage.BACKGROUND_IMAGE,
      src: url,
      originalWidth: width,
      originalHeight: height,
      width,
      height,
      // Reset scaling so the user can start from scratch
      referenceLength: null,
      point1X: null,
      point1Y: null,
      point2X: null,
      point2Y: null,
    })
    navigate(`..${routes.modals.scaleImage}`, { relative: 'path' })
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>{getTitle('editImage')}</title>
        </Helmet>
        <Modal
          isDismissable
          isOpen={this.state.isOpen}
          onOpenChange={open => this.setState({ isOpen: open })}
          onAnimationComplete={animation => {
            if (animation === MODAL_ANIMATION_VARIANT.hidden) this.props.navigate('..', { relative: 'path' })
          }}
          className="max-w-3xl"
        >
          <Dialog>
            <Heading slot="title" className="text-lg pb-3 mb-3 border-b">
              Edit Image
            </Heading>
            <div id="filestack-ref" />
          </Dialog>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = ({ objects }) => ({
  backgroundImage: objects.present.backgroundImage,
})

const mapDispatchToProps = dispatch => ({
  onUpdateBackgroundImage(backgroundImage) {
    dispatch(updateBackgroundImage({ backgroundImage }))
  },
})

export default compose(appConnect(mapStateToProps, mapDispatchToProps), withNavigate)(EditImageModal)
